import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetail } from "@/components/site/ServiceDetail";
import tenancyAssetUrl from "@/assets/svc-tenancy.webp";
const tenancyAsset = { url: tenancyAssetUrl };

export const Route = createFileRoute("/services/end-of-tenancy")({
  head: () => ({
    meta: [
      { title: "End of Tenancy Cleaning in Tidworth & Salisbury | IZHUB" },
      { name: "description", content: "Inspection-ready end of tenancy cleaning across Tidworth, Andover and Salisbury. Full property cleans for tenants, landlords and letting agents. Instant quote online." },
      { property: "og:title", content: "End of Tenancy Cleaning | IZHUB Cleaning Services" },
      { property: "og:description", content: "Inspection-ready end of tenancy cleans for tenants, landlords and letting agents across Salisbury Plain." },
      { property: "og:url", content: "https://izhubcleaning.uk/services/end-of-tenancy" },
    ],
    links: [{ rel: "canonical", href: "https://izhubcleaning.uk/services/end-of-tenancy" }],
  }),
  component: TenancyPage,
});

function TenancyPage() {
  return (
    <ServiceDetail
      data={{
        title: "End of Tenancy Cleaning",
        heroTitle: <>Move out with your <span className="rainbow-text">deposit protected</span>.</>,
        intro: "Inspection-ready end of tenancy cleaning for tenants, landlords and letting agents across Tidworth, Andover and Salisbury.",
        image: tenancyAsset.url,
        imageAlt: "A spotless empty property ready for checkout inspection",
        forWho: "Tenants moving out, landlords between lets, letting agents preparing inspections.",
        quoteService: "tenancy",
        includes: [
          "Full property clean to inspection standard",
          "Inside cupboards, drawers, oven interior and appliances",
          "Bathroom descale, limescale and mould treatment",
          "Skirting boards, door frames, switches and fittings",
          "Internal windows, sills and tracks",
          "Optional add-ons: carpets, windows inside, upholstery",
        ],
        paragraphs: [
          "Checkout inspections are strict, and cleaning is the number one reason deposits are disputed. Our end of tenancy cleans follow an inspection-standard checklist that covers the whole property: inside appliances, inside cupboards, limescale, grout, and all the detail areas agents check first.",
          "For tenants, that means the best possible chance of a full deposit return. For landlords and letting agents, it means a property that's genuinely ready for new arrivals, turned around quickly and reliably.",
          "We work with tenants, landlords and agents across Tidworth, Andover, Salisbury, Amesbury and the Salisbury Plain area. Get an instant fixed estimate online, or send us the checkout report on WhatsApp and we'll tailor the clean to it.",
        ],
      }}
    />
  );
}
